module.exports = __webpack_public_path__ + "static/bastian-nolte-5014277c95aa0b25ce472da310414a7e.jpg";